import { useMemo } from 'react';
import dayjs from 'dayjs';
import { queries } from 'RestAPIs/rapini';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import { ActivitiesForm } from './components/ActivitiesForm';
import { useGetColumns } from './hooks/useGetColumns';

const Activities = () => {
  const columns = useGetColumns();

  const {
    data: activities,
    isFetching,
    refetch,
    isError
  } = queries.useGetActivities(
    // @ts-expect-error TODO: BE should accept array of ids
    'WORKPLACE',
    undefined,
    true
  );

  // The date range is set to 99 years to include all valid functions from now to the future.
  const {
    data: allFunctions,
    isLoading: isLoadingFunctions,
    isError: isFunctionsError
  } = queries.useGetFunctions(
    dayjs().format('YYYY-MM-DD'),
    dayjs().add(99, 'year').format('YYYY-MM-DD'),
    false,
    undefined,
    false
  );

  // Create a Map for O(1) lookup instead of O(n) find operations
  const functionsMap = useMemo(() => {
    return new Map(allFunctions?.map((f) => [f.entityId, f]) ?? []);
  }, [allFunctions]);

  const rows = useMemo(
    () =>
      activities?.map((activity) => ({
        ...activity,
        id: activity.entityId,
        requiredQualificationsDisplay:
          activity.requiredQualifications
            ?.map((q) => q.name ?? '')
            .filter((name) => name !== '')
            .join(', ') ?? '',
        allowedFunctionsDisplay:
          activity.allowedFunctionIds
            ?.map((id) => {
              const func = functionsMap.get(id);
              return func?.description || func?.code || '';
            })
            .filter((name) => name !== '')
            .join(', ') ?? ''
      })) ?? [],
    [activities, functionsMap]
  );

  return (
    <TableCRUDLayout
      FormComponent={ActivitiesForm}
      rows={rows}
      loading={isFetching || isLoadingFunctions}
      columns={columns}
      initialState={{
        sorting: { sortModel: [{ field: 'name', sort: 'asc' }] }
      }}
      hasLoadingError={isError || isFunctionsError}
      onLoadingError={refetch}
    />
  );
};

export default Activities;
